/**
 * Move keyboard focus to the element with the given id on the next
 * frame (after React has committed the post-delete DOM). Used by the
 * conditional-action control's delete affordances so focus doesn't fall to
 * `<body>` when the focused element is removed (WCAG 2.4.3).
 *
 * The control's form fields carry path-derived ids (added for the
 * label/autofill a11y fixes), so callers can target the element that
 * should receive focus by reconstructing its id.
 */
export const focusById = (id: string): void => {
  requestAnimationFrame(() => {
    document.getElementById(id)?.focus();
  });
};
